import dayjs from 'dayjs';

import { doRequest } from '@r1-frontend/do-request';
import { IPacketDto } from '@r1-frontend/api-domru/api-epg/v1/dto/IPacketDto';
import { IProgram } from '@r1-frontend/api-domru/api-epg/v1/dto/IProgram';
import { getPackageChannels } from '@r1-frontend/api-domru/api-epg/v1/packets';
import { getProgram } from '@r1-frontend/api-domru/api-epg/v1/programs';

import { getFinishDate } from '../program/helpers';

interface IGetTvPacketList {
    providerId: number,
    packetId: number,
}

interface IGetProgram {
    channel: string,
    dateFrom: string,
    dateTo: string,
}

interface IGetSchedule {
    xvidArray: number[],
    startDate: Date,
    time: {
        start: {
            hour: number,
            minute: number,
        },
        finish: {
            hour: number,
            minute: number,
        },
    },
}

export async function getTvPacketInfo({ providerId, packetId }: IGetTvPacketList) {
    const response = await doRequest.apiEPG<IPacketDto[]>(
        getPackageChannels(providerId, { active: 1, packetIds: [packetId], with: 'channels' }),
    );

    const packageInfo = response.isSuccess ? response.payload[0] : { body: '', title: '' };
    const channels = (response.isSuccess && response.payload[0]?.channels)
        ? response.payload[0].channels.map(channel => ({
                ...channel,
                button: channel.lcn,
                logo: channel?.channelInfo?.logo,
                chid: channel.channelId,
                xvid: channel.epgId,
                bids: packetId,
                biglogo: channel?.channelInfo?.bigLogo ||  channel?.channelInfo?.logo,
            }))
        : [];

    return { ...packageInfo, channels };
}

export const getPacketsChannels = async(providerId: number) =>{
    const response = await doRequest.apiEPG<IPacketDto[]>(
        getPackageChannels(providerId, {
            active: 1,
            with: 'channels',
        }),
    );
    // TODO переписать на reduce
    if (response.isSuccess) {
        return response.payload.map(item => {
            const { channels = [] } = item;

            let hdChannelsCount = 0;
            let sdChannelsCount = 0;
            channels.forEach(({ quality }) => quality === 'HD' ? hdChannelsCount += 1 : sdChannelsCount += 1);
            return ({
                id: (item.billing_id || '').toString(),
                name: item.title,
                description: item.body,
                price: (item.price || 0).toString(),
                hdChannelsCount: hdChannelsCount,
                sdChannelsCount: sdChannelsCount,
                image: item.image680x280,
                alias: item.alias_second,
            });
        });
    }
    return [];
};

export const getProgramChannel = async({ channel, dateFrom, dateTo }: IGetProgram) => {
    const dateStartFormat = new Date(dateFrom);
    const dateFinishFormat = new Date(dateTo);
    const params = {
        startTo: dateFinishFormat.toISOString(),
        startFrom: dateStartFormat.toISOString(),
        order: '+start',
        epgIds: `["${encodeURIComponent(channel)}"]`,
    };
    return await doRequest.apiEPG<IProgram[]>(
        getProgram(params),
    );
};

export const getSchedule = async({ xvidArray, startDate, time }: IGetSchedule) => {
    const { start, finish } = time;
    const finishDate = getFinishDate(startDate, finish);

    const dateStartFormat = dayjs(startDate).hour(start?.hour ?? 0).minute(start?.minute ?? 0);
    const dateFinishFormat = finishDate;

    const xvidParameter = xvidArray.map((epgId) => `"${encodeURIComponent(epgId)}"`);
    const params = {
        startTo: dateFinishFormat.toISOString(),
        startFrom: dateStartFormat.toISOString(),
        order: '+start',
        epgIds: `[${xvidParameter}]`,
    };
    return await doRequest.apiEPG<IProgram[]>(
        getProgram(params),
    );
};
